/* ============================================
   YALMA — where nature begins
   Custom Shopify Theme JavaScript
   Vanilla JS only — no jQuery
   ============================================ */

(function () {
  'use strict';

  /* --- Musteriye gorunen kisa etiketler ---
     Bu dort etiketi JS'in kendisi yaziyor (sayfa yuklenirken DOM'da
     yoklar), o yuzden Liquid'den gecemiyorlardi ve sabit kodlanmislardi.
     Artik tema ayarindan geliyorlar: layout/theme.liquid sayfaya
     window.yalmaStrings basiyor. Ayar bossa ya da kopru hic
     basilmamissa asagidaki yedek kullanilir — metin birebir ayni,
     yalnizca kaynagi degisti; hicbir dugme etiketsiz kalmaz. */
  function yalmaText(key, fallback) {
    var store = window.yalmaStrings;
    if (store && typeof store[key] === 'string' && store[key] !== '') return store[key];
    return fallback;
  }

  /* --- Hero Background Video ---
     Video preload="none"; kaynagi yalnizca su kosullarda yuklenir:
     - prefers-reduced-motion KAPALI (aksi halde video hic yuklenmez)
     - masaustu VEYA mobilde acikca izin verilmis (data-video-mobile)
     Yuklenmezse poster/gorsel oldugu gibi kalir. */
  (function initHeroVideo() {
    var video = document.querySelector('[data-hero-video]');
    if (!video) return;

    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) return;

    var isMobile = window.matchMedia('(max-width: 768px)').matches;
    var allowMobile = video.getAttribute('data-video-mobile') === 'true';
    if (isMobile && !allowMobile) return;

    var src = video.getAttribute('data-video-src');
    if (!src) return;

    video.setAttribute('src', src);
    video.muted = true;
    var playAttempt = video.play();
    if (playAttempt && typeof playAttempt.catch === 'function') {
      playAttempt.catch(function () { /* autoplay engellenirse poster kalir */ });
    }
  })();

  /* --- Mobile Navigation --- */

  const mobileToggle = document.querySelector('[data-mobile-toggle]');
  const mobileNav = document.querySelector('[data-mobile-nav]');
  const mobileClose = document.querySelector('[data-mobile-close]');

  if (mobileToggle && mobileNav) {
    mobileToggle.addEventListener('click', function () {
      mobileNav.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
  }

  if (mobileClose && mobileNav) {
    mobileClose.addEventListener('click', function () {
      mobileNav.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  }

  /* --- Cart Drawer --- */

  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const cartOverlay = document.querySelector('[data-cart-overlay]');
  const cartToggles = document.querySelectorAll('[data-cart-toggle]');
  const cartClose = document.querySelector('[data-cart-close]');

  function openCartDrawer() {
    if (cartDrawer) cartDrawer.classList.add('is-open');
    if (cartOverlay) cartOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeCartDrawer() {
    if (cartDrawer) cartDrawer.classList.remove('is-open');
    if (cartOverlay) cartOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  cartToggles.forEach(function (toggle) {
    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      openCartDrawer();
    });
  });

  if (cartClose) {
    cartClose.addEventListener('click', closeCartDrawer);
  }

  if (cartOverlay) {
    cartOverlay.addEventListener('click', closeCartDrawer);
  }

  /* --- Add to Cart (AJAX) --- */

  const productForms = document.querySelectorAll('[data-product-form]');

  productForms.forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var formData = new FormData(form);
      var data = {
        id: formData.get('id'),
        quantity: 1
      };

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      })
        .then(function (response) { return response.json(); })
        .then(function () {
          refreshCartDrawer();
          openCartDrawer();
        })
        .catch(function (error) {
          console.error('Add to cart error:', error);
        });
    });
  });

  function refreshCartDrawer() {
    fetch('/cart.js')
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        updateCartDrawerContent(cart);
      });
  }

  function updateCartCount(count) {
    var countEls = document.querySelectorAll('.yalma-header__cart-count');
    countEls.forEach(function (el) {
      el.textContent = '(' + count + ')';
    });

    var drawerTitle = document.querySelector('.yalma-cart-drawer__title');
    if (drawerTitle) {
      drawerTitle.textContent = yalmaText('cartTitle', 'Cart') + ' (' + count + ')';
    }
  }

  function updateCartDrawerContent(cart) {
    var itemsContainer = document.querySelector('[data-cart-items]');
    if (!itemsContainer) return;

    if (cart.item_count === 0) {
      itemsContainer.innerHTML = '<p class="yalma-cart-drawer__empty">Your bag is empty.</p>';
    } else {
      var html = '';
      cart.items.forEach(function (item) {
        html += '<div class="yalma-cart-drawer__item">';
        html += '  <div class="yalma-cart-drawer__item-image">';
        if (item.image) {
          html += '    <img src="' + getSizedImageUrl(item.image, '160x') + '" alt="' + escapeHtml(item.title) + '" loading="lazy">';
        }
        html += '  </div>';
        html += '  <div>';
        html += '    <div class="yalma-cart-drawer__item-name">' + escapeHtml(item.product_title) + '</div>';
        var variantLabel = (item.variant_title && item.variant_title !== 'Default Title')
          ? escapeHtml(item.variant_title) + ' &middot; '
          : '';
        html += '    <div class="yalma-cart-drawer__item-variant">' + variantLabel + 'Qty ' + item.quantity + '</div>';
        html += '    <div class="yalma-cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</div>';
        html += '  </div>';
        html += '</div>';
      });
      itemsContainer.innerHTML = html;
    }

    var subtotalEl = document.querySelector('.yalma-cart-drawer__subtotal span:last-child');
    if (subtotalEl) {
      subtotalEl.textContent = formatMoney(cart.total_price);
    }

    var checkoutBtn = document.querySelector('.yalma-cart-drawer__checkout');
    if (checkoutBtn) {
      checkoutBtn.style.display = cart.item_count > 0 ? 'block' : 'none';
    }
  }

  /* --- Variant Picker (renk + beden birlikte) ---
     Secilen TUM secenekleri birlikte eslestirip dogru varyanti bulur.
     Buton stok durumu secilen varyantin gercek .available degerinden
     okunur — '9999 stok ama Sold Out' hatasi (yanlis varyant eslesmesi)
     boylece cozulur. Renk secilince gorsel + renk adi da guncellenir. */
  (function initVariantPicker() {
    var form = document.querySelector('[data-product-form]');
    if (!form || typeof window.yalmaProductVariants === 'undefined') return;

    var variants = window.yalmaProductVariants;
    var idInput = form.querySelector('[data-variant-id]');
    var addBtn = form.querySelector('[data-add-btn]');
    var addLabel = form.querySelector('[data-add-label]');
    var addText = addBtn ? addBtn.getAttribute('data-add-text') : 'Add to Bag';
    var soldText = addBtn ? addBtn.getAttribute('data-sold-text') : 'Sold Out';
    var priceEl = document.querySelector('.yalma-product__price');
    var selectedColorEl = document.querySelector('[data-selected-color]');
    // Yalnizca butonlar — acilir menunun degeri gizli input'ta durur
    var optionButtons = form.querySelectorAll('button[data-option-position]');
    var optionSelects = form.querySelectorAll('input[data-option-position]');

    function currentSelection() {
      var sel = {};
      form.querySelectorAll('button[data-option-position].is-selected').forEach(function (b) {
        sel[b.getAttribute('data-option-position')] = b.getAttribute('data-value');
      });
      // Acilir menuyle secilen secenekler — deger gizli input'ta
      Array.prototype.forEach.call(optionSelects, function (el) {
        if (el.value !== '') sel[el.getAttribute('data-option-position')] = el.value;
      });
      return sel;
    }

    // Hicbir secenek onceden secili degil; hepsi secilene kadar sepete eklenmez
    function allChosen() {
      return Array.prototype.every.call(optionSelects, function (el) { return el.value !== ''; });
    }

    function findVariant(sel) {
      return variants.find(function (v) {
        return Object.keys(sel).every(function (pos) {
          return v['option' + pos] === sel[pos];
        });
      });
    }

    function setSoldOut() {
      if (!addBtn) return;
      addBtn.disabled = true;
      if (addLabel) addLabel.textContent = soldText;
    }

    // Galeriyi yalnizca RENGE gore tazele — beden secilmemis olsa bile.
    // Musteri rengi secer, gorsel degismezse urunun o renkte olmadigini
    // sanip cikiyor.
    function refreshGalleryForColour() {
      if (!Gallery || !Gallery.filterByVariant || !Gallery.hasMedia()) return;
      var sel = currentSelection();
      var keys = Object.keys(sel);
      if (!keys.length) return;
      // Secilen degerlerle uyusan ilk varyanti bul; eksik secenekleri
      // serbest birak
      var match = variants.find(function (v) {
        return keys.every(function (pos) { return v['option' + pos] === sel[pos]; });
      });
      if (match) Gallery.filterByVariant(match.id);
    }

    function update() {
      if (!allChosen()) {
        if (addBtn) {
          addBtn.disabled = true;
          if (addLabel) addLabel.textContent = addBtn.getAttribute('data-choose-text') || addText;
        }
        refreshGalleryForColour();
        return;
      }

      var sel = currentSelection();
      var v = findVariant(sel);

      if (!v) { setSoldOut(); return; }

      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = formatMoney(v.price);

      if (addBtn) {
        if (v.available) {
          addBtn.disabled = false;
          if (addLabel) addLabel.textContent = addText;
        } else {
          setSoldOut();
        }
      }

      // Secili renk adi — artik acilir menuden okunur
      if (selectedColorEl) {
        var colorInput = form.querySelector('[data-select][data-option-name="color"] [data-select-input], [data-select][data-option-name="colour"] [data-select-input], [data-select][data-option-name="renk"] [data-select-input]');
        if (colorInput) selectedColorEl.textContent = colorInput.value;
      }
      // Galeri secili varyanta gore filtrelenir
      if (Gallery && Gallery.filterByVariant && Gallery.hasMedia()) {
        Gallery.filterByVariant(v.id);
      }
    }

    optionButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var pos = btn.getAttribute('data-option-position');
        form.querySelectorAll('[data-option-position="' + pos + '"]').forEach(function (b) {
          b.classList.remove('is-selected');
        });
        btn.classList.add('is-selected');
        update();
      });
    });

    Array.prototype.forEach.call(optionSelects, function (el) {
      el.addEventListener('change', update);
    });

    // Ilk yuklemede buton durumunu secim durumuna gore ayarla
    if (optionSelects.length) update();
  })();

  /* --- Product Gallery: kucuk resimler + ileri/geri oklari + renge ozel filtre ---
     Tek bir galeri durumu (state) tutulur: gosterilen gorsel listesi ve
     aktif indeks. Renk secilince liste filtrelenir, ilk gorsele donulur. */
  /* --- Varyant galerisi ---
     Butun medya sayfa yuklenirken DOM'a basilir; renk degisince yalnizca
     gizle/goster yapilir. Ag istegi yok, yer sicramasi yok.

     Ana gorsel tek bir <img>; kaynagini aktif kucuk resmin data alanlarindan
     alir. Boylece 80 gorselli bir urunde 160 degil 81 <img> olur.

     Kucuk resim sayisi sinirlidir (masaustu/mobil ayri) ve "Hepsini goster"
     sayisi FILTRELENMIS sete gore yazilir, toplama gore degil. */
  var Gallery = (function () {
    var root = document.querySelector('[data-gallery]');
    if (!root) return { hasMedia: function () { return false; } };

    var stage = root.querySelector('[data-gallery-stage]');
    var main = root.querySelector('[data-gallery-main]');
    var thumbsWrap = root.querySelector('[data-gallery-thumbs]');
    var prevBtn = root.querySelector('[data-gallery-prev]');
    var nextBtn = root.querySelector('[data-gallery-next]');
    var moreBtn = root.querySelector('[data-gallery-more]');
    var all = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-thumb]'));
    if (!all.length) return { hasMedia: function () { return false; } };

    var shown = [];        // su an gorunen kucuk resimler
    var index = 0;         // gorunen set icindeki konum
    var expanded = false;  // "Hepsini goster" acildi mi

    function cap() {
      var d = parseInt(root.getAttribute('data-thumbs-desktop'), 10) || 6;
      var m = parseInt(root.getAttribute('data-thumbs-mobile'), 10) || 4;
      return window.matchMedia('(max-width: 768px)').matches ? m : d;
    }

    function show(i) {
      if (!shown.length || !main) return;
      index = (i + shown.length) % shown.length;
      var t = shown[index];

      var full = t.getAttribute('data-full');
      var srcset = t.getAttribute('data-srcset');
      var alt = t.getAttribute('data-alt') || '';
      // Oran sifir ya da gecersiz gelirse yukseklik sonsuz olur ve
      // tarayici gorseli hic cizmez — bu yuzden aciktan korunuyor.
      var ratio = parseFloat(t.getAttribute('data-ratio'));
      if (!ratio || !isFinite(ratio) || ratio <= 0) ratio = 0.8;

      if (full) {
        main.src = full;
        if (srcset) main.srcset = srcset;
        main.alt = alt;
        // Yukseklik onceden yazilir ki gorsel degisince sayfa zilamasin
        main.width = 1000;
        main.height = Math.round(1000 / ratio);
      }

      all.forEach(function (b) {
        b.classList.remove('is-active');
        b.removeAttribute('aria-current');
      });
      t.classList.add('is-active');
      t.setAttribute('aria-current', 'true');

      syncArrows();
    }

    function syncArrows() {
      var many = shown.length > 1;
      [prevBtn, nextBtn].forEach(function (b) { if (b) b.hidden = !many; });
    }

    function applyCap() {
      var limit = expanded ? shown.length : cap();
      shown.forEach(function (t, i) { t.classList.toggle('is-over-cap', i >= limit); });

      if (!moreBtn) return;
      var hidden = shown.length - limit;
      if (hidden > 0) {
        moreBtn.hidden = false;
        moreBtn.textContent = yalmaText('galleryShowAll', 'Show all ({{ n }})')
          .replace('{{ n }}', shown.length);
      } else if (expanded && shown.length > cap()) {
        moreBtn.hidden = false;
        moreBtn.textContent = yalmaText('galleryShowFewer', 'Show fewer');
      } else {
        moreBtn.hidden = true;
      }
    }

    // Varyanta gore filtrele. Listesi bos olan varyantta zaten her sey
    // "all" olarak isaretli gelir, o yuzden burada ekstra yedek gerekmez.
    function filterByVariant(variantId) {
      var id = String(variantId || '');
      shown = all.filter(function (t) {
        var owners = t.getAttribute('data-variant-ids') || 'all';
        if (owners === 'all' || owners === '') return true;
        return owners.split(',').indexOf(id) !== -1;
      });
      // Hicbiri eslesmediyse hepsini goster — bos galeri asla
      if (!shown.length) shown = all.slice();

      all.forEach(function (t) { t.classList.add('is-filtered-out'); });
      shown.forEach(function (t) { t.classList.remove('is-filtered-out'); });

      expanded = false;
      applyCap();
      show(0);
      root.setAttribute('data-current-variant', id);
    }

    all.forEach(function (t, i) {
      t.addEventListener('click', function () {
        var pos = shown.indexOf(t);
        show(pos < 0 ? 0 : pos);
      });
    });

    if (prevBtn) prevBtn.addEventListener('click', function () { show(index - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { show(index + 1); });

    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        expanded = !expanded;
        applyCap();
      });
    }

    // Klavye: sahne odaktayken sol/sag oklar
    if (stage) {
      stage.setAttribute('tabindex', '0');
      stage.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); show(index - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); show(index + 1); }
      });

      // Dokunmatikte yatay kaydirma
      var x0 = null, y0 = null;
      stage.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) return;
        x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
      }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var t = e.changedTouches[0];
        var dx = t.clientX - x0, dy = t.clientY - y0;
        // Dikey kaydirmayi bozma: yatay hareket baskin ve yeterince uzun olmali
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) {
          show(dx < 0 ? index + 1 : index - 1);
        }
        x0 = null; y0 = null;
      }, { passive: true });
    }

    window.addEventListener('resize', applyCap);

    // Ilk durum: sayfadaki secili varyant
    filterByVariant(root.getAttribute('data-current-variant'));

    return {
      hasMedia: function () { return all.length > 0; },
      filterByVariant: filterByVariant
    };
  })();

  /* --- Koleksiyon kategori filtresi ---
     Shopify'in "Search & Discovery" ayarina bagli DEGIL: kategoriler
     urunun Type alanindan gelir, filtreleme sayfa icinde yapilir.
     Coklu secim; her secim bir cip, cipe basinca o kategori kalkar.
     Mega-menuden gelen ?filter.p.product_type=... adresi de okunur. */
  (function initCollectionFilter() {
    var root = document.querySelector('[data-filter]');
    if (!root) return;

    var toggle = root.querySelector('[data-filter-toggle]');
    var panel = root.querySelector('[data-filter-panel]');
    var chipsWrap = root.querySelector('[data-filter-chips]');
    var countEl = root.querySelector('[data-filter-count]');
    var clearBtn = root.querySelector('[data-filter-clear]');
    var boxes = Array.prototype.slice.call(root.querySelectorAll('[data-filter-type]'));
    // Katalog artik editoryal satir duzeninde; eski izgara da destekleniyor.
    var grid = document.querySelector('.yalma-collection__rows') || document.querySelector('.yalma-collection__grid');
    var cards = grid ? Array.prototype.slice.call(grid.querySelectorAll('[data-type]')) : [];
    if (!cards.length) return;

    var PARAM = 'filter.p.product_type';
    var emptyMsg = null;

    function selected() {
      return boxes.filter(function (b) { return b.checked; }).map(function (b) { return b.value; });
    }

    function renderChips(sel) {
      chipsWrap.innerHTML = '';
      sel.forEach(function (val) {
        var chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'yalma-filter__chip';
        chip.setAttribute('aria-label', val + ' — remove');
        chip.innerHTML = '<span>' + val + '</span><span class="yalma-filter__chip-x" aria-hidden="true">&times;</span>';
        chip.addEventListener('click', function () {
          boxes.forEach(function (b) { if (b.value === val) b.checked = false; });
          apply();
        });
        chipsWrap.appendChild(chip);
      });
    }

    function updateUrl(sel) {
      if (!window.history || !window.history.replaceState) return;
      var url = new URL(window.location.href);
      url.searchParams.delete(PARAM);
      sel.forEach(function (v) { url.searchParams.append(PARAM, v); });
      window.history.replaceState({}, '', url.toString());
    }

    function apply() {
      var sel = selected();
      var shown = 0;
      cards.forEach(function (card) {
        var type = card.getAttribute('data-type') || '';
        var ok = sel.length === 0 || sel.indexOf(type) !== -1;
        card.style.display = ok ? '' : 'none';
        if (ok) shown++;
      });

      renderChips(sel);
      updateUrl(sel);
      if (countEl) countEl.textContent = shown + (shown === 1 ? ' item' : ' items');

      // Sonuc yoksa bilgilendir
      if (!shown) {
        if (!emptyMsg && grid) {
          emptyMsg = document.createElement('div');
          emptyMsg.className = 'yalma-filter__empty';
          emptyMsg.textContent = yalmaText('filterEmpty', 'Nothing in this category yet.');
          grid.appendChild(emptyMsg);
        }
        if (emptyMsg) emptyMsg.style.display = '';
      } else if (emptyMsg) {
        emptyMsg.style.display = 'none';
      }
    }

    // Genis ekranda filtre bir sol sutundur ve hep acik durur; acilir-kapanir
    // davranis yalnizca dar ekranda gecerlidir.
    //
    // Panelin GORUNURLUGUNU CSS belirler, JS degil. JS yalnizca data-open
    // isaretini ve aria durumunu tasir. Sebep: gorunurluk JS'in sayfa
    // yuklenirken yaptigi genislik olcumune baglandiginda, olcumun gec
    // kesinlestigi yerlerde (ornek: iframe, gec yerlesen duzen) panel yanlis
    // modda kilitli kaliyordu. CSS medya sorgusu boyle bir zamanlamaya
    // bagli degil; JS hic calismasa bile genis ekranda panel acik gelir.
    var compact = window.matchMedia('(max-width: 900px)');
    function isCompact() { return compact.matches; }
    function panelOpen() { return root.hasAttribute('data-open'); }

    function openPanel(open) {
      if (open) root.setAttribute('data-open', '');
      else root.removeAttribute('data-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      var caret = toggle.querySelector('.yalma-filter__caret');
      if (caret) caret.textContent = open ? '−' : '+';
    }

    function syncAria() {
      // Genis ekranda panel gorunur oldugu icin aria da acik demeli
      toggle.setAttribute('aria-expanded', isCompact() ? (panelOpen() ? 'true' : 'false') : 'true');
    }

    toggle.addEventListener('click', function () {
      if (!isCompact()) return;
      openPanel(!panelOpen());
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isCompact() && panelOpen()) { openPanel(false); toggle.focus(); }
    });
    document.addEventListener('click', function (e) {
      if (isCompact() && panelOpen() && !root.contains(e.target)) openPanel(false);
    });
    if (compact.addEventListener) compact.addEventListener('change', syncAria);
    else if (compact.addListener) compact.addListener(syncAria);
    // Duzen gec yerlestiginde ilk olcum yaniltici olabiliyor; aria'yi
    // yeniden boyutlanmada ve tam yuklemede de tazele.
    window.addEventListener('resize', syncAria);
    window.addEventListener('load', syncAria);
    syncAria();

    boxes.forEach(function (b) { b.addEventListener('change', apply); });
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        boxes.forEach(function (b) { b.checked = false; });
        apply();
      });
    }

    // Mega-menuden gelen adresteki kategoriler secili baslasin
    try {
      var params = new URL(window.location.href).searchParams.getAll(PARAM);
      if (params.length) {
        boxes.forEach(function (b) {
          if (params.indexOf(b.value) !== -1) b.checked = true;
        });
      }
    } catch (e) { /* eski tarayici: filtre yine de elle calisir */ }

    apply();
  })();

  /* --- Beden rehberi penceresi --- */
  (function initSizeGuide() {
    var modal = document.querySelector('[data-size-guide]');
    if (!modal) return;
    var openers = document.querySelectorAll('[data-size-guide-open]');
    var closers = modal.querySelectorAll('[data-size-guide-close]');
    var lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      var c = modal.querySelector('.yalma-size-guide__close');
      if (c) c.focus();
    }
    function close() {
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    openers.forEach(function (b) { b.addEventListener('click', open); });
    closers.forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
    });
  })();

  /* --- Renk kutulari: temanin ICINE gomulu renk sozlugu ---
     Onceki surumde renkler yalnizca tema editorundeki "Colour swatches"
     listesinden geliyordu. O liste bos oldugunda butun kutular gri kaliyordu.
     Artik sozluk temanin kendi dosyasinda: hicbir ayar yapilmasa da renkler
     gorunur. Oncelik sirasi degismedi —
       1) Shopify'in kendi swatch'i, 2) tema editorundeki liste,
       3) buradaki gomulu sozluk, 4) notr gri.
     Ad karsilastirmasi buyuk/kucuk harf, bosluk ve tireden bagimsizdir:
     "French Navy", "french navy" ve "FRENCH-NAVY" ayni renge duser. */
  var YALMA_COLOR_FALLBACK = {
    black: '#1A1A18', jetblack: '#111110', deepblack: '#141412',
    white: '#FFFFFF', offwhite: '#F4F1EA', vintagewhite: '#EFEAE1',
    naturalraw: '#E3DCCB', natural: '#E3DCCB', raw: '#E3DCCB',
    cream: '#EDE6D6', ecru: '#E2DAC8', ivory: '#F2EDE1',
    beige: '#D8CBB4', sand: '#D6C7A8', stone: '#C4BBAA', taupe: '#A3968A',
    heathergrey: '#B9B7B2', heathergray: '#B9B7B2', greymelange: '#B9B7B2',
    grey: '#9A9A96', gray: '#9A9A96',
    lightgrey: '#CFCEC9', lightgray: '#CFCEC9',
    darkgrey: '#5A5A57', darkgray: '#5A5A57',
    charcoal: '#3A3A38', anthracite: '#3B3C3E', silver: '#C7C7C4',
    frenchnavy: '#1E2A44', navy: '#1E2A44', midnightblue: '#1B2440',
    blue: '#2F5DA8', brightblue: '#2C5DA8', royalblue: '#2B4FA2',
    skyblue: '#8FB8DE', lightblue: '#A9C8E4', babyblue: '#BBD4E8',
    denim: '#48688C', workerblue: '#45606F', stargazer: '#5A6A78',
    petrol: '#2A5560', teal: '#2E6A6A', turquoise: '#3FA9A6', aqua: '#69C2C0',
    green: '#4A6B45', bottlegreen: '#1F4032', forestgreen: '#2F4A38',
    glazedgreen: '#6C7A5B', olive: '#6B6B45', khaki: '#85815E',
    armygreen: '#5A5F45', sagegreen: '#A3B191', sage: '#A3B191',
    aloe: '#A9B49F', mint: '#A9CFC0', lime: '#A8C34A',
    red: '#B3261E', brightred: '#C0271F', darkred: '#8A1F1A',
    burgundy: '#6B2737', wine: '#5E2233', maroon: '#5F2028',
    rust: '#9C4A24', terracotta: '#B5654A', brick: '#9E4A38',
    orange: '#D2691E', apricot: '#E8A87C', peach: '#F0C0A0',
    coral: '#E2725B', salmon: '#E9927E',
    pink: '#E7A9B8', cottonpink: '#E7C4C8', rose: '#C98895',
    dustypink: '#C79A9A', fuchsia: '#C2377C', magenta: '#B93A82',
    purple: '#6B4E8C', lilac: '#B9A7CE', lavender: '#C6BBDD',
    plum: '#6A3D5B', aubergine: '#4A2A3E',
    yellow: '#E3B341', mustard: '#C99A2E', ochre: '#C08A2E',
    gold: '#C8A84B', butter: '#F0DFA0',
    brown: '#6B4A32', chocolate: '#4A322A', coffee: '#4E3B2E',
    camel: '#B08A5E', caramel: '#A9743F', tan: '#C09A6B',
    cognac: '#8B4F2A', mocha: '#6E5646'
  };

  function yalmaColorKey(name) {
    return String(name || '').toLowerCase().replace(/[^a-z0-9]/g, '');
  }

  (function paintMissingSwatches() {
    var missing = document.querySelectorAll('.yalma-swatch[data-swatch-missing]');
    if (!missing.length) return;
    var unresolved = [];
    missing.forEach(function (b) {
      var hex = YALMA_COLOR_FALLBACK[yalmaColorKey(b.getAttribute('data-value'))];
      if (hex) {
        b.style.setProperty('--swatch', hex);
        b.removeAttribute('data-swatch-missing');
      } else {
        unresolved.push(b.getAttribute('data-value'));
      }
    });
    if (unresolved.length) {
      console.warn(
        '[YALMA] Bu renkler hicbir kaynakta bulunamadi, notr gri gosteriliyor: ' +
        unresolved.join(', ') +
        ' — Tema editoru > Settings > Colour swatches listesine "Ad: #hex" olarak ekleyin.'
      );
    }
  })();

  /* --- Sertifika bilgi baloncugu (dokunmatik) ---
     Hover ve klavye odagi CSS ile calisir. Dokunmatikte dokununca acilir,
     disariya dokununca / Esc ile kapanir. */
  (function initCertTooltips() {
    var certs = document.querySelectorAll('[data-cert]');
    if (!certs.length) return;

    function closeAll() {
      certs.forEach(function (c) { c.classList.remove('is-open'); });
    }

    certs.forEach(function (cert) {
      var btn = cert.querySelector('[data-cert-toggle]');
      if (!btn) return;
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var willOpen = !cert.classList.contains('is-open');
        closeAll();
        if (willOpen) cert.classList.add('is-open');
      });
    });

    document.addEventListener('click', closeAll);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });
  })();

  /* --- Product Image Zoom (Desktop) --- */

  var mainImageWrap = document.querySelector('.yalma-product__main-image');

  if (mainImageWrap && window.innerWidth > 1024) {
    mainImageWrap.addEventListener('mousemove', function (e) {
      var img = mainImageWrap.querySelector('img');
      if (!img) return;

      var rect = mainImageWrap.getBoundingClientRect();
      var x = ((e.clientX - rect.left) / rect.width) * 100;
      var y = ((e.clientY - rect.top) / rect.height) * 100;

      img.style.transformOrigin = x + '% ' + y + '%';
      img.style.transform = 'scale(1.5)';
    });

    mainImageWrap.addEventListener('mouseleave', function () {
      var img = mainImageWrap.querySelector('img');
      if (img) {
        img.style.transform = 'scale(1)';
        img.style.transformOrigin = 'center center';
      }
    });
  }

  /* --- Collapsible Sections --- */

  var collapsibles = document.querySelectorAll('[data-collapsible]');

  collapsibles.forEach(function (section) {
    var toggle = section.querySelector('[data-collapsible-toggle]');
    if (toggle) {
      toggle.addEventListener('click', function () {
        section.classList.toggle('is-open');
      });
    }
  });

  /* --- Cart Page Quantity & Remove --- */

  document.querySelectorAll('[data-qty-minus]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var key = btn.getAttribute('data-key');
      var span = btn.parentElement.querySelector('span');
      var qty = parseInt(span.textContent, 10);
      if (qty > 1) {
        updateCartItem(key, qty - 1);
      }
    });
  });

  document.querySelectorAll('[data-qty-plus]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var key = btn.getAttribute('data-key');
      var span = btn.parentElement.querySelector('span');
      var qty = parseInt(span.textContent, 10);
      updateCartItem(key, qty + 1);
    });
  });

  document.querySelectorAll('[data-remove-item]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var key = btn.getAttribute('data-key');
      updateCartItem(key, 0);
    });
  });

  function updateCartItem(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (response) { return response.json(); })
      .then(function () {
        window.location.reload();
      })
      .catch(function (error) {
        console.error('Cart update error:', error);
      });
  }

  /* --- Utilities --- */

  function formatMoney(cents) {
    /* Liquid'deki money_without_trailing_zeros ile tutarli:
       yuvarlak tutarda kurus yok (€70), kusuratta virgullu (€89,99) */
    var value = (cents / 100).toFixed(2).replace('.', ',');
    return '€' + value.replace(/,00$/, '');
  }

  function escapeHtml(text) {
    var div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  function getSizedImageUrl(url, size) {
    if (!url) return '';
    var match = url.match(/\.(jpg|jpeg|png|gif|webp)(\?|$)/i);
    if (match) {
      return url.replace(match[0], '_' + size + '.' + match[1] + (match[2] || ''));
    }
    return url;
  }

/* --- Editoryal urun karti: galeri ve yerinde sepete ekleme ---
     Her kart kendi gorsellerini tasir; oklar ve noktalar yalnizca o kartin
     kutusunda calisir. Add to Cart sayfayi degistirmez: tek varyantli urun
     dogrudan sepete gider, birden fazla varyant varsa kartin icinde kompakt
     bir secici acilir. */
  (function initEditorialCards() {
    var cards = document.querySelectorAll('[data-ecard]');
    if (!cards.length) return;

    Array.prototype.forEach.call(cards, function (card) {
      var imgs = Array.prototype.slice.call(card.querySelectorAll('[data-ecard-img]'));
      var dots = Array.prototype.slice.call(card.querySelectorAll('[data-ecard-dot]'));
      var prev = card.querySelector('[data-ecard-prev]');
      var next = card.querySelector('[data-ecard-next]');
      var media = card.querySelector('.yalma-ecard__media');
      var current = 0;

      function show(i) {
        if (!imgs.length) return;
        current = (i + imgs.length) % imgs.length;
        imgs.forEach(function (im, n) { im.classList.toggle('is-active', n === current); });
        dots.forEach(function (d, n) {
          d.classList.toggle('is-active', n === current);
          if (n === current) d.setAttribute('aria-current', 'true');
          else d.removeAttribute('aria-current');
        });
      }

      if (prev) prev.addEventListener('click', function () { show(current - 1); });
      if (next) next.addEventListener('click', function () { show(current + 1); });
      dots.forEach(function (d, n) { d.addEventListener('click', function () { show(n); }); });

      // Sol/sag ok tuslari — odak kartin gorsel kutusundayken
      if (media && imgs.length > 1) {
        media.setAttribute('tabindex', '0');
        media.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowLeft') { e.preventDefault(); show(current - 1); }
          if (e.key === 'ArrowRight') { e.preventDefault(); show(current + 1); }
        });
      }

      /* --- Sepete ekleme --- */
      var addBtn = card.querySelector('[data-ecard-add]');
      var variantWrap = card.querySelector('[data-ecard-variants]');
      var status = card.querySelector('[data-ecard-status]');
      if (!addBtn) return;

      function say(msg) { if (status) status.textContent = msg || ''; }

      function addToCart(id, btn) {
        var label = btn ? btn.textContent : '';
        if (btn) btn.disabled = true;
        say('');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('add failed');
            return r.json();
          })
          .then(function () {
            if (variantWrap) { variantWrap.hidden = true; addBtn.setAttribute('aria-expanded', 'false'); }
            if (typeof refreshCartDrawer === 'function') refreshCartDrawer();
            if (typeof openCartDrawer === 'function') openCartDrawer();
          })
          .catch(function () {
            say('Could not add this. Please try again.');
          })
          .then(function () {
            if (btn) { btn.disabled = false; if (label) btn.textContent = label; }
          });
      }

      if (variantWrap) {
        addBtn.addEventListener('click', function () {
          var open = variantWrap.hidden;
          variantWrap.hidden = !open;
          addBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
          if (open) {
            var first = variantWrap.querySelector('[data-ecard-variant]:not([disabled])');
            if (first) first.focus();
          }
        });

        variantWrap.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') {
            variantWrap.hidden = true;
            addBtn.setAttribute('aria-expanded', 'false');
            addBtn.focus();
          }
        });

        Array.prototype.forEach.call(variantWrap.querySelectorAll('[data-ecard-variant]'), function (b) {
          b.addEventListener('click', function () {
            if (b.disabled) return;
            addToCart(b.getAttribute('data-variant-id'), b);
          });
        });
      } else {
        var singleId = addBtn.getAttribute('data-variant-id');
        if (singleId) {
          addBtn.addEventListener('click', function () { addToCart(singleId, addBtn); });
        }
      }
    });
  })();

/* --- SSS akordeonu ---
     Her soru bir <button>; aria-expanded ve hidden birlikte guncellenir,
     boylece ekran okuyucu ile gorsel durum ayni seyi soyler. */
  (function initFaq() {
    var toggles = document.querySelectorAll('[data-faq-toggle]');
    if (!toggles.length) return;

    Array.prototype.forEach.call(toggles, function (btn) {
      var answer = document.getElementById(btn.getAttribute('aria-controls'));
      if (!answer) return;
      var icon = btn.querySelector('.yalma-faq__icon');

      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        answer.hidden = open;
        if (icon) icon.textContent = open ? '+' : '−';
      });
    });
  })();

/* --- Marka acilir menusu (beden secici) ---
     Native <select> yerine: acilan listeyi isletim sistemi degil biz ciziyoruz,
     boylece menu de krem/siyah/altin paletinde kaliyor. Native select'in bedava
     verdigi seyleri elle karsiliyoruz: ok tuslari, Home/End, Enter/Space,
     Escape, harfe basinca atlama, disari tiklayinca kapanma, odak yonetimi. */
  (function initYalmaSelect() {
    var roots = document.querySelectorAll('[data-select]');
    if (!roots.length) return;

    Array.prototype.forEach.call(roots, function (root) {
      var btn = root.querySelector('[data-select-button]');
      var list = root.querySelector('[data-select-list]');
      var valueEl = root.querySelector('[data-select-value]');
      var input = root.querySelector('[data-select-input]');
      if (!btn || !list || !input) return;

      var options = Array.prototype.slice.call(list.querySelectorAll('[data-select-option]'));
      if (!options.length) return;
      // Hicbiri secili degilse listede ilk secenek "aktif" baslar ama
      // kutuda yer tutucu ("Select color") yazmaya devam eder.
      var activeIndex = Math.max(0, options.findIndex(function (o) {
        return o.getAttribute('aria-selected') === 'true';
      }));

      function isOpen() { return !list.hidden; }

      function setActive(i, scroll) {
        activeIndex = (i + options.length) % options.length;
        options.forEach(function (o, n) { o.classList.toggle('is-active', n === activeIndex); });
        var opt = options[activeIndex];
        list.setAttribute('aria-activedescendant', opt.id || '');
        if (scroll && opt.scrollIntoView) opt.scrollIntoView({ block: 'nearest' });
      }

      function open() {
        list.hidden = false;
        btn.setAttribute('aria-expanded', 'true');
        root.setAttribute('data-open', '');
        setActive(activeIndex, true);
        list.focus();
      }

      function close(focusBtn) {
        list.hidden = true;
        btn.setAttribute('aria-expanded', 'false');
        root.removeAttribute('data-open');
        if (focusBtn) btn.focus();
      }

      function choose(i) {
        var opt = options[i];
        if (!opt) return;
        options.forEach(function (o) {
          o.classList.remove('is-selected');
          o.setAttribute('aria-selected', 'false');
        });
        opt.classList.add('is-selected');
        opt.setAttribute('aria-selected', 'true');
        var val = opt.getAttribute('data-value');
        if (valueEl) {
          valueEl.textContent = val;
          valueEl.classList.remove('is-placeholder');
        }
        input.value = val;
        // Varyant secici bu olayi dinliyor
        input.dispatchEvent(new Event('change', { bubbles: true }));
        close(true);
      }

      btn.addEventListener('click', function () {
        if (isOpen()) close(false); else open();
      });

      options.forEach(function (o, n) {
        o.addEventListener('click', function () { choose(n); });
        o.addEventListener('mousemove', function () { setActive(n, false); });
      });

      list.addEventListener('keydown', function (e) {
        switch (e.key) {
          case 'ArrowDown': e.preventDefault(); setActive(activeIndex + 1, true); break;
          case 'ArrowUp': e.preventDefault(); setActive(activeIndex - 1, true); break;
          case 'Home': e.preventDefault(); setActive(0, true); break;
          case 'End': e.preventDefault(); setActive(options.length - 1, true); break;
          case 'Enter':
          case ' ': e.preventDefault(); choose(activeIndex); break;
          case 'Escape': e.preventDefault(); close(true); break;
          case 'Tab': close(false); break;
          default:
            if (e.key && e.key.length === 1) {
              var ch = e.key.toLowerCase();
              for (var k = 1; k <= options.length; k++) {
                var idx = (activeIndex + k) % options.length;
                if ((options[idx].textContent || '').trim().toLowerCase().indexOf(ch) === 0) {
                  setActive(idx, true); break;
                }
              }
            }
        }
      });

      btn.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' ') {
          e.preventDefault(); open();
        }
      });

      document.addEventListener('click', function (e) {
        if (isOpen() && !root.contains(e.target)) close(false);
      });
    });
  })();

/* --- Hukuki sayfa: sayfa ici gezinme ---
     Metin temaya gomulu oldugu icin liste blok ayarlarindan uretilemiyor;
     bunun yerine sayfadaki h2 basliklarindan kuruluyor. Iki ya da daha az
     baslik varsa liste hic basilmaz — tek basliga icindekiler gerekmez. */
  (function initLegalToc() {
    var main = document.querySelector('[data-legal-main]');
    if (!main) return;

    var heads = Array.prototype.slice.call(main.querySelectorAll('.yalma-legal__section-title'));
    if (heads.length < 2) return;

    var header = main.querySelector('.yalma-legal__header');
    if (!header) return;

    var nav = document.createElement('nav');
    nav.className = 'yalma-legal__toc';
    nav.setAttribute('aria-label', 'On this page');

    var label = document.createElement('div');
    label.className = 'yalma-legal__toc-label';
    label.textContent = yalmaText('tocLabel', 'On this page');
    nav.appendChild(label);

    var ol = document.createElement('ol');
    ol.className = 'yalma-legal__toc-list';

    heads.forEach(function (h, i) {
      var sec = h.closest ? h.closest('.yalma-legal__section') : null;
      var id = (sec && sec.id) || h.id;
      if (!id) { id = 'legal-auto-' + i; if (sec) sec.id = id; else h.id = id; }
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + id;
      a.textContent = (h.textContent || '').trim();
      li.appendChild(a);
      ol.appendChild(li);
    });

    nav.appendChild(ol);
    header.parentNode.insertBefore(nav, header.nextSibling);
  })();

/* --- Aforizma — her acilista listeden biri ---
     Ilk satir sunucudan basili geliyor; JavaScript kapaliysa o kalir.
     Burada yalnizca rastgele bir digeriyle degistiriliyor. */
  (function initAphorism() {
    var root = document.querySelector('[data-aphorism]');
    if (!root) return;
    var el = root.querySelector('[data-aphorism-text]');
    var cite = root.querySelector('[data-aphorism-cite]');
    var raw = root.getAttribute('data-lines') || '';
    var pool = raw.split('||').filter(function (s) { return s.trim() !== ''; });
    if (!el || pool.length < 2) return;

    var picked = pool[Math.floor(Math.random() * pool.length)];
    // "soz — konusan" bicimi; tire yoksa hepsi sozdur
    var split = picked.split(' \u2014 ');
    el.textContent = split[0].trim();
    if (cite) {
      if (split.length > 1) {
        cite.textContent = split.slice(1).join(' \u2014 ').trim();
        cite.hidden = false;
      } else {
        cite.textContent = '';
        cite.hidden = true;
      }
    }
  })();

})();
